import type React from "react";

import { useEventListener } from "@app/components/search-form-hydrated/autocomplete-input-hydrated/hooks/use-event-listener";

export const useClickOutside = <T extends keyof DocumentEventMap>(
  refs: Array<
    React.RefObject<HTMLDivElement> | React.Ref<HTMLElement> | undefined
  >,
  cb: (e: Event) => void,
  eventType = "mousedown" as T
) => {
  useEventListener(eventType, e => {
    // Get the path of elements that were clicked, including through shadow DOM
    const composedPath = e.composedPath();

    // Check if any element in the path is either the dropdown or the anchor
    for (const ref of refs) {
      if (!ref || !("current" in ref) || !ref.current) {
        continue;
      }

      // If the click path contains the ref element, it was a click inside
      if (composedPath.includes(ref.current)) {
        return;
      }
    }

    // If we reach here, the click was outside all the refs
    cb(e);
  });
};
